import { BubblehousePointsRounding } from "@redotech/congo-enums/bubblehouse-points-rounding";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const bubblehouseSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    shopSlug: z.string().trim().min(1, "Shop slug is required"),
    pointsPerDollar: z.number().positive(),
    pointsRounding: z.enum(BubblehousePointsRounding),
  },
  secrets: {
    keyId: z.string().trim().min(1, "Key ID is required"),
    sharedSecret: z
      .string()
      .trim()
      .pipe(z.base64("Shared secret must be base64-encoded")),
  },
  connectOnly: {},
  computed: {},
});
